import React from 'react';
import { Button } from 'semantic-ui-react';
import { useFormContext } from 'react-hook-form';
import { ShouldRender } from 'components/ShouldRender';
import { FormattedMessage, useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { DeleteAccessRule } from '../../../DeleteAccessRule';
import { useAccessManagement2NModal } from '../../../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../../../discardChanges';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {

  const intl = useIntl();
  const modal = useModal();
  const formContext = useFormContext();
  const accessManagement2NModal = useAccessManagement2NModal();

  return (
    <div className={styles.formActions}>
      <div className={styles.actionContainer}>
        <Button
          basic
          name="cancel-access-rule-details"
          type="button"
          disabled={isLoading}
          onClick={() => discardChanges('accessRule', null, intl, accessManagement2NModal, modal)}
        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          name="submit-access-rule-details"
          disabled={isLoading || !formContext?.formState?.isDirty}
          loading={isLoading}
          onClick={formContext.handleSubmit(onSubmit)}
        >
          <FormattedMessage id="saveChanges" />
        </Button>
      </div>
      <ShouldRender condition={!!accessManagement2NModal.selected.accessRule}>
        <DeleteAccessRule />
      </ShouldRender>
    </div>
  );
};
